export default __webpack_public_path__ + "static/media/contact_us.35f73801.svg";